import * as Sentry from "@sentry/browser";
import "./nodelist-foreach-polyfill";

(async () => {
    if (!self.fetch) {
        await import(/* webpackChunkName: "fetch-polyfill" */ "whatwg-fetch");
        Sentry.captureMessage("fetch polyfill loaded", Sentry.Severity.Info);
    }
    if (!("Promise" in self)) {
        await import(/* webpackChunkName: "promise-polyfill" */"promise-polyfill/src/polyfill");
        Sentry.captureMessage("promise polyfill loaded", Sentry.Severity.Info);
    }
})();
